import cn from 'classnames'
import Pagination from 'components/Pagination'
import {useEffect, useState, useRef} from 'react'
import {toast} from 'react-toastify'
import Layout from '../Layout'
import {Loader} from '../Loader'
import NavBar from '../Navbar'
import withAuthorization from '../Session/withAuthorization'
import Table from '../TableComponent'
import styles from './PublicQuestions.module.scss'
import {deletePublicQuestion, answerPublicQuestion} from 'components/apis/publicQuestions'
import {Trash, QuestionMarkCircle, EditIcon} from 'assets/svgs'
import ConfirmModal from 'components/ConfirmModal'
import ModalComponent from 'components/ModalComponent'
import InputField from '../InputField'
import {searchWithAlgolia} from '../utils'
import AlgoliaClient, {PUBLIC_QUESTIONS_ALGOLIA_INDEX} from '../AlgoliaSearch'
import {useAppContext, useFirebase, useSession} from 'components/Firebase/hooks'
import debounce from 'lodash/debounce'
import React from 'react'
import {TABLE_PAGINATION_PAGE_SIZE} from 'components/constants'
import TextTruncate from './TextTruncate'
import DetailModal from './DetailModal'
interface IPublicQuestionData {
  productId: string
  productName: string
  questionId: string
  text: string
  answer?: string
  name: string
  answeredByAdmin?: boolean
  adminName?: string
}

const PublicQuestions = ({customClass}: {customClass: string}) => {
  const {user} = useSession()
  const [accountList, setAccountList] = useState<Array<string>>([])
  const {getUserAccounts} = useFirebase()
  const {
    appState: {isMSAAdmin, isSuperAdmin, isSuperManager}
  } = useAppContext()
  const getMSAAccountsList = async () => {
    const userAccounts = await getUserAccounts()
    const accountIDLength = userAccounts.length
    if (accountIDLength) {
      !accountList.length && setAccountList([...userAccounts])
    }
  }
  useEffect(() => {
    if (isMSAAdmin) {
      getMSAAccountsList()
    }
  }, [])
  const [pageCount, setPageCount] = useState(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const searchIndex = AlgoliaClient.initIndex(PUBLIC_QUESTIONS_ALGOLIA_INDEX)
  const [deleted, setDeleted] = useState<string | null>(null)
  const [questionsData, setData] = useState<Array<IPublicQuestionData>>([])
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [loader, setLoader] = useState(true)
  const [currentQuestion, setCurrentQuestion] =
    useState<IPublicQuestionData | null>(null)
  const [disableDelete, setDisableDelete] = useState(false)
  const [showAnswerModal, setShowAnswerModal] = useState(false)
  const [answerText, setAnswerText] = useState('')
  const [disableAnswer, setDisableAnswer] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [showDetailModal, setShowDetailModal] = useState(false)
  const [detailModalData, setDetailModalData] = useState<{title: string; content: string}>({title: '', content: ''})
  const handleDeleteQuestion = async () => {
    setDisableDelete(true)
    deleteQuestion()
  }

  const handleAnswerQuestion = async () => {
    if (!answerText.trim()) return
    setDisableAnswer(true)
    
    const {productId, questionId} = currentQuestion as IPublicQuestionData
    if (!productId || !questionId) return
    
    const response = await answerPublicQuestion({productId, questionId, answer: answerText, adminName : user?.displayName || 'Admin'})
    const {code, msg} = response?.data || {}
    
    if (code === 200) {
      toast.success(msg)
      setShowAnswerModal(false)
      setCurrentQuestion(null)
      setAnswerText('')
      
      // Update the current question in the list immediately
      setData(prevData => 
        prevData.map(q => 
          q.questionId === questionId 
            ? {...q, answer: answerText, answeredByAdmin: true, adminName: user?.displayName || 'Admin'}
            : q
        )
      )
      
      await AlgoliaClient.clearCache()
      setTimeout(() => {
        if (isMSAAdmin && accountList.length) {
          searchWithAlgolia<IPublicQuestionData>({
            searchQuery: searchValue || '*',
            searchIndex,
            setLoaderState: setLoader,
            setData,
            setPageCount,
            accountList,
            currentPage,
            numberOfHits: TABLE_PAGINATION_PAGE_SIZE,
            sortData: false
          }).then(() => setLoader(false))
        }
        if (isSuperAdmin || isSuperManager) {
          searchWithAlgolia<IPublicQuestionData>({
            searchQuery: searchValue || '*',
            searchIndex,
            setLoaderState: setLoader,
            setData,
            setPageCount,
            accountList,
            currentPage,
            numberOfHits: TABLE_PAGINATION_PAGE_SIZE,
            sortData: false
          }).then(() => setLoader(false))
        }
      }, 500)
    } else {
      setDisableAnswer(false)
      toast.warn('Something went wrong, Please try again later!')
      setShowAnswerModal(false)
      setCurrentQuestion(null)
      setAnswerText('')
    }
  }
  const [dir, setDir] = useState<{key: string; dir: string}>({
    key: '',
    dir: 'asc'
  })
  const deleteQuestion = async () => {
    setLoader(true)
    const {productId, questionId} = currentQuestion as IPublicQuestionData
    if (!productId || !questionId) return
    const {
      data: {data, code}
    } = await deletePublicQuestion({productId, questionId})
    if (code === 200) {
      setDeleted(questionId)
      toast.success(data.msg)
      setShowConfirmModal(false)
      setCurrentQuestion(null)
      await AlgoliaClient.clearCache()
      setTimeout(() => {
        if (isMSAAdmin && accountList.length) {
          searchWithAlgolia<IPublicQuestionData>({
            searchQuery: searchValue || '*',
            searchIndex,
            setLoaderState: setLoader,
            setData,
            setPageCount,
            accountList,
            currentPage,
            numberOfHits: TABLE_PAGINATION_PAGE_SIZE,
            sortData: false
          }).then(() => setLoader(false))
        }
        if (isSuperAdmin || isSuperManager) {
          searchWithAlgolia<IPublicQuestionData>({
            searchQuery: searchValue || '*',
            searchIndex,
            setLoaderState: setLoader,
            setData,
            setPageCount,
            accountList,
            currentPage,
            numberOfHits: TABLE_PAGINATION_PAGE_SIZE,
            sortData: false
          }).then(() => setLoader(false))
        }
      }, 500)
    } else {
      setLoader(false)
      toast.warn(`Something went wrong, Please try again later!`)
      setShowConfirmModal(false)
      setCurrentQuestion(null)
    }
  }

  useEffect(() => {
    AlgoliaClient.clearCache()
    if (isMSAAdmin && accountList.length) {
      searchWithAlgolia<IPublicQuestionData>({
        searchQuery: '*',
        searchIndex,
        setLoaderState: setLoader,
        setData,
        setPageCount,
        accountList,
        currentPage,
        numberOfHits: TABLE_PAGINATION_PAGE_SIZE,
        sortData: false
      }).then(() => setLoader(false))
    }
    if (isSuperAdmin || isSuperManager) {
      searchWithAlgolia<IPublicQuestionData>({
        searchQuery: '*',
        searchIndex,
        setLoaderState: setLoader,
        setData,
        setPageCount,
        accountList,
        currentPage,
        numberOfHits: TABLE_PAGINATION_PAGE_SIZE,
        sortData: false
      }).then(() => setLoader(false))
    }
  }, [accountList?.length])

  const getRowData = (rowData: Array<IPublicQuestionData>) => {
    return (rowData || []).map((question, index) => {
      if (deleted === question.questionId) {
        return null
      }
      return (
        <tr key={`public-questions-row-data-${index}`}>
          {/* <td>{question.productId || '-'}</td> */}
          <td>{question.productName || '-'}</td>
          <td>
            {question.text ? (
              <TextTruncate
                text={question.text}
                wordLimit={10}
                onClick={() => {
                  setDetailModalData({title: 'Question', content: question.text})
                  setShowDetailModal(true)
                }}
              />
            ) : (
              '-'
            )}
          </td>
          <td>
            {question?.answer ? (
              <div className={styles.answerContainer}>
                <TextTruncate
                  text={question.answer}
                  wordLimit={8}
                  onClick={() => {
                    setDetailModalData({title: 'Answer', content: question.answer || ''})
                    setShowDetailModal(true)
                  }}
                />
                {question?.answeredByAdmin && (
                  <span className={styles.adminBadge}>
                    {question?.adminName || 'Admin'}
                  </span>
                )}
              </div>
            ) : (
              '-'
            )}
          </td>
          <td>{question.name || '-'}</td>
          <td>
            <div className={styles.actionButtons}>
              {question?.answer ? (
                <div className={styles.tooltipContainer}>
                  <button
                    className={styles.actionBtn}
                    onClick={(e) => {
                      e.stopPropagation()
                      setCurrentQuestion(question)
                      setAnswerText(question.answer || '')
                      setShowAnswerModal(true)
                      setDisableAnswer(false)
                    }}
                  >
                    <EditIcon />
                  </button>
                  <span className={styles.tooltip}>Edit Answer</span>
                </div>
              ) : (
                <div className={styles.tooltipContainer}>
                  <button
                    className={styles.actionBtn}
                    onClick={(e) => {
                      e.stopPropagation()
                      setCurrentQuestion(question)
                      setAnswerText('')
                      setShowAnswerModal(true)
                      setDisableAnswer(false)
                    }}
                  >
                    <QuestionMarkCircle />
                  </button>
                  <span className={styles.tooltip}>Answer Question</span>
                </div>
              )}
              <div className={styles.tooltipContainer}>
                <button
                  className={styles.actionBtn}
                  onClick={(e) => {
                    e.stopPropagation()
                    setCurrentQuestion(question)
                    setShowConfirmModal(true)
                    setDisableDelete(false)
                  }}
                >
                  <Trash />
                </button>
                <span className={styles.tooltip}>Delete Question</span>
              </div>
            </div>
          </td>
        </tr>
      )
    })
  }

  const scrollRef: React.RefObject<HTMLDivElement> = React.createRef()

  const scrollToRef = () =>
    scrollRef?.current?.scrollIntoView({behavior: 'smooth'})

  const showPagination = pageCount > TABLE_PAGINATION_PAGE_SIZE

  const onPageChange = (page: number) => {
    setLoader(true)
    setCurrentPage(page)
    debouncedSearch?.current({
      searchQuery: searchValue,
      searchIndex,
      setLoaderState: setLoader,
      setData,
      setPageCount,
      accountList,
      currentPage: page,
      numberOfHits: TABLE_PAGINATION_PAGE_SIZE,
      sortData: false
    })
    setLoader(false)
    scrollToRef()
  }
  const debouncedSearch = useRef(
    debounce(searchWithAlgolia<IPublicQuestionData>, 500)
  )

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isMSAAdmin && !accountList?.length) return
    const value = event?.target?.value
    setSearchValue(value)
    if (value) {
      setCurrentPage(1)
      debouncedSearch?.current({
        searchQuery: value,
        searchIndex,
        setLoaderState: setLoader,
        setData,
        setPageCount,
        accountList,
        numberOfHits: TABLE_PAGINATION_PAGE_SIZE,
        sortData: false
      })
    } else {
      debouncedSearch?.current({
        searchQuery: '*',
        searchIndex,
        setLoaderState: setLoader,
        setData,
        setPageCount,
        accountList,
        currentPage,
        numberOfHits: TABLE_PAGINATION_PAGE_SIZE,
        sortData: false
      })
    }
  }


  const sortBy = async (keys: Array<string>) => {
    setLoader(true)
    let newDir = 'asc'
    if (dir.key === keys[0]) {
      newDir = dir.dir === 'asc' ? 'desc' : 'asc'
    }
    setDir({dir: newDir, key: keys[0]})
    await searchIndex.setSettings({
      customRanking: keys.map((key) => newDir + '(' + key + ')')
    })
    await AlgoliaClient.clearCache()
    setCurrentPage(1)
    setTimeout(() => {
      debouncedSearch?.current({
        searchQuery: searchValue,
        searchIndex,
        setLoaderState: setLoader,
        setData,
        setPageCount,
        currentPage: 1,
        sortData: false
      })
    }, 1000);
  }

  const tableTitles = [
    // {title: 'Equipment ID'},
    {title: 'Equipment Name', sortBy: () => sortBy(['productName'])},
    {title: 'Question', sortBy: () => sortBy(['text'])},
    {title: 'Answer', sortBy: () => sortBy(['answer'])},
    {title: 'Contact Name', sortBy: () => sortBy(['name'])},
    {title: 'Action'}
  ]

  return (
    <div className={styles.withLayout}>
      <Layout />
      <div className={cn(styles.container, customClass)}>
        <NavBar title="Public Questions" />
        <div className={styles.button_filters}>
          <InputField
            name="questionSearchField"
            isSearch={true}
            type="text"
            value={searchValue}
            onChange={handleSearch}
            customClass={styles.inputField}
            placeholder="Search for Filters"
          />
        </div>
        {loader ? (
          <Loader />
        ) : (
          <React.Fragment>
            <Table
              customClass={styles.threedetails}
              titles={tableTitles}
              rowData={getRowData(questionsData)}
            />
            {showPagination && (
              <div className="pagination__wrapper">
                <Pagination
                  currentPage={currentPage}
                  totalCount={pageCount}
                  pageSize={TABLE_PAGINATION_PAGE_SIZE}
                  onPageChange={onPageChange}
                />
              </div>
            )}
          </React.Fragment>
        )}

        <ModalComponent
          show={showConfirmModal}
          handleClose={() => setShowConfirmModal(false)}
        >
          <ConfirmModal
            content="Are you sure you want to delete this question?"
            text={currentQuestion?.text || ''}
            handleClose={() => setShowConfirmModal(false)}
            handleConfirm={handleDeleteQuestion}
            confirmBtnDisabled={disableDelete}
            hasInput={false}
          />
        </ModalComponent>

        <ModalComponent
          show={showAnswerModal}
          handleClose={() => setShowAnswerModal(false)}
        >
          <ConfirmModal
            content="Answer Question"
            text={currentQuestion?.text || ''}
            handleClose={() => setShowAnswerModal(false)}
            handleConfirm={handleAnswerQuestion}
            confirmBtnDisabled={disableAnswer || !answerText.trim()}
            hasInput={true}
            inputValue={answerText}
            onInputChange={(e) => setAnswerText(e.target.value)}
            inputPlaceholder="Enter your answer..."
            inputType="textarea"
            confirmBtnText="Submit"
          />
        </ModalComponent>

        <DetailModal
          show={showDetailModal}
          onClose={() => setShowDetailModal(false)}
          title={detailModalData.title}
          content={detailModalData.content}
        />
      </div>
    </div>
  )
}

export default withAuthorization(PublicQuestions)
